<template>
  <v-container class="px-10">
    <v-row justify="center">
      <v-col md="12">
        <v-btn color="success" class="my-9 text-capitalize" @click="display = true"
        >{{ $t('hr.payment.add') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col class="mt-8">
        <h3 class="mb-2">{{ $t($router.currentRoute.name) }}</h3>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          class="mb-3"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table :dark="$store.state.isDarkMode"
          :search="search"
          :headers="headers"
          id="table"
          :items="data"
          :loading="$store.state.payinstallment.loading"
          style="border: 1px solid #999"
          :options.sync="$store.state.payinstallment.options"
          :server-items-length="$store.state.payinstallment.serverTotal"
          disable-sort
        >
          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-center">
              <v-icon
                color="red"
                style="cursor: pointer"
                class="px-2"
                @click="handleDelete(item)"
              >mdi-delete
              </v-icon>
              <v-icon
                color="blue"
                class="mx-2"
                style="cursor: pointer"
                @click="handleDisplay(item)"
              >mdi-eye
              </v-icon>
            </div>

          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <PayInstallmentModal v-model="display" :item="item" :isDis="isDis"></PayInstallmentModal>
  </v-container>
</template>
<script>
import axios from "axios";
import {mapActions, mapGetters} from "vuex";
import PayInstallmentModal from "@/views/dashboard/modules/pay-installments/PayInstallmentModal.vue";

export default {
  components: {PayInstallmentModal},
  data() {
    return {
      search: '',
      display: false,
      item: null,
      isDis: false,
    };
  },
  mounted() {
    this.fetch()
  },
  watch: {
    "$store.state.payinstallment.options": function () {
      this.fetch()
    },
  },
  computed: {
    ...mapGetters({
      data: 'payinstallment/data',
      headers: 'payinstallment/headers'
    })
  },
  methods: {
    ...mapActions({
      fetch: 'payinstallment/fetch',
      delete: 'payinstallment/delete',
      setPayment: 'payinstallment/setPayment'
    }),
    handleDisplay(item) {
      this.display = true
      this.isDis = true
      console.log(item);
      this.setPayment(item)
      this.item = item
    },
    async handleDelete(item) {
      await this.delete(item.id)
    },
    // handleEdit(item) {
    //   this.item = item
    //   this.display = true
    // },
  },
};
</script>
<style scoped>
#table >>> th, #table >>> td {
  text-align: center !important;
}
</style>
